export default {
      id: "ohm-logo-usage",
      viewBox: "0 0 696 186",
      url: "/" + "assets/sprite.svg#ohm-logo",
      toString: function () {
        return this.url;
      }
    }